import { ajaxURL } from "./variables";

window.addEventListener("load", function () {


    this.document.addEventListener('click', async function(e) {

        if (e.target && e.target.classList.contains('vote-button')) {
            const button = e.target;
            // get data-post-id attribute value
            const post_id = button.getAttribute('data-post-id');
            // alert(post_id);
            const formData = new FormData();
            formData.append('action', 'cast_manual_vote');
            formData.append('post_id', post_id);
            formData.append('nonce', spp.nonce);

            let response = await  fetch(ajaxURL, {
                method: 'POST',
                body: formData
            });

            let result = await response.json();

            console.log(result);

            if (result.success) {
                
                // button.innerHTML = `Voted!`;
                // button.disabled = true;
                document.getElementById('total-vote-count-' + post_id).textContent = result.data.votes;
                // button.replaceWith(document.createElement('p').textContent = 'You have voted this cycle.');
                button.textContent = 'You have voted this cycle.';
                button.disabled = true; // Disable the button after voting
                // get closest .steam-game-item and add class .user-voted
                button.closest('.steam-game-item').classList.add('user-voted');
            } else {
                alert('Error: ' + result.data.message);
            }


            // error handling
        }


        // unvote-button
        if(e.target && e.target.classList.contains('unvote-button')) {
            const button = e.target;
            // get data-post-id attribute value
            const post_id = button.getAttribute('data-post-id');
            // alert(post_id);
            const formData = new FormData();
            formData.append('action', 'unvote');
            formData.append('post_id', post_id);
            formData.append('nonce', spp.nonce);

            let response = await  fetch(ajaxURL, {
                method: 'POST',
                body: formData
            });

            let result = await response.json();

            console.log(result);

            if (result.success) {
                // button.innerHTML = `Voted!`;
                // button.disabled = true;
                document.getElementById('total-vote-count-' + post_id).textContent = result.data.votes;
                button.textContent = 'Vote';
                button.disabled = false;
                // get closest .steam-game-item and remove class .user-voted
                button.closest('.steam-game-item').classList.remove('user-voted');
                // button.replaceWith(document.createElement('p').textContent = 'You have unvoted this post.');
            } else {
                alert('Error: ' + result.data.message);
            }
        }




    });


});